import { Middleware } from 'redux';
import { AGREEMENT_OBJECT, RENTAL_OBJECT } from 'core/datasets/action';
import { DateTime } from 'luxon';
import { parseSelectedRentalAgreementValidFromDate } from 'tenantUser/utils/parseSelectedRentalAgreementValidFromDate';
import { rentalObjectsActions } from '../rentalObjectActions';
import { queryMeterReadings } from 'meterReading/gql/queryMeterReadings';
import CHART_X_UNIT from 'meterReading/datasets/chart_x_unit';
import { getMeterLinksData } from 'rentalObject/utils/getMeterLinksData';

const rentalObjectMiddleware: Middleware =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        next(action);

        switch (action?.type) {
            case RENTAL_OBJECT.REQUEST_METER_READINGS_DATA_INTO_STORE: {
                const { payload } = action;
                if (!payload.objectId) return;

                const parsedFromDate = parseSelectedRentalAgreementValidFromDate(payload.date || '');
                const fromDate = parsedFromDate
                    ? parsedFromDate.minus({ months: 2 }).startOf('month').toSQLDate()
                    : null;
                const toDate = DateTime.now().plus({ months: 2 }).toSQLDate();

                const options = {
                    rentalObjectId: payload.objectId,
                    ...(fromDate && { range: { fromDate, toDate } }),
                };

                dispatch(
                    rentalObjectsActions.fetchMeterReadings(
                        queryMeterReadings,
                        options,
                        RENTAL_OBJECT.RECEIVE_METER_READINGS,
                    ),
                );
                break;
            }

            case RENTAL_OBJECT.RECEIVE_METER_READINGS: {
                const { payload } = action;
                const meterReadingsData = payload.data?.meterReadings || [];
                const selectedObjectID = getState().agreementObjects.selectedObjectID;

                dispatch(rentalObjectsActions.putMeterReadingsData(meterReadingsData));
                dispatch(
                    rentalObjectsActions.setChartsData({
                        metersData: meterReadingsData,
                        chartsUnit: CHART_X_UNIT.MONTH,
                        meterChartsLinks: getMeterLinksData(meterReadingsData, selectedObjectID as number),
                    }),
                );
                break;
            }

            case AGREEMENT_OBJECT.AGREEMENT_OBJECT_SELECTED: {
                dispatch(rentalObjectsActions.cleanChartsData());
                break;
            }

            case RENTAL_OBJECT.SET_CHARTS_DATA: {
                const { payload } = action;
                localStorage.setItem('rentalObjects', JSON.stringify({ chartsDataSet: payload }));
                break;
            }

            default:
                break;
        }
    };

export default rentalObjectMiddleware;
